import { CANVAS_ZOOM_MAX, CANVAS_ZOOM_MIN } from '../constants/canvas-zoom'

/** Multiplier on `(scaleRatio - 1)` per gesturechange tick (WebKit pinch); >1 feels closer to browser chrome. */
const SAFARI_PINCH_GESTURE_RATIO_MULTIPLIER = 6.45

/**
 * Zoom level after one Safari `gesturechange` tick, rounded to 3 decimals: `rawRatio` is the
 * gesture scale relative to the previous tick, amplified and applied to `current`, then clamped.
 */
export function computeSafariPinchZoom(current: number, rawRatio: number): number {
  const factor = 1 + (rawRatio - 1) * SAFARI_PINCH_GESTURE_RATIO_MULTIPLIER

  return +Math.max(CANVAS_ZOOM_MIN, Math.min(CANVAS_ZOOM_MAX, current * factor)).toFixed(3)
}
